import { render } from "./SignageComponent.vue?vue&type=template&id=39a4aa93"
import script from "./SignageComponent.vue?vue&type=script&lang=js"
export * from "./SignageComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__